import { classes } from '~/helpers';
import { HTMLCustomElement } from '~/html-custom-element';

if (!customElements.get('table-of-contents')) {
  customElements.define(
    'table-of-contents',
    class TableOfContents extends HTMLCustomElement {
      get headings() {
        return (
          this.targets.link &&
          this.targets.link.all
            .map((link) => {
              const { hash } = new URL(link.href);

              if (!hash) return null;

              const heading = document.querySelector(hash);

              if (heading) {
                return {
                  heading,
                  link,
                };
              }

              return null;
            })
            .filter(Boolean)
        );
      }

      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();

        this.on('scroll', window, this.handleScroll.bind(this), { passive: true }, true);

        /**
         * On component load.
         */
        this.handleScroll();
      }

      /**
       * Handles the window scroll event.
       */
      handleScroll() {
        const offset = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height')) + 33;

        let current = null;

        for (const { heading } of this.headings) {
          const top = heading.getBoundingClientRect().top;

          if (top - offset <= 0) {
            current = heading;
          } else {
            break;
          }
        }

        if (current) {
          const match = this.headings.find(({ heading }) => heading === current);

          if (match) {
            this.setCurrentLink(match.link);
          }
        }
      }

      /**
       * Sets the current active link.
       * @param {HTMLElement} element - The link to set as active.
       */
      setCurrentLink(element) {
        if (this.current === element) {
          return;
        }

        this.current = element;

        this.targets.link.all.forEach((link) => {
          link.classList.toggle(classes.active, link === element);
        });
      }
    }
  );
}
